module.exports = __webpack_public_path__ + "img/shouqian_zixun.4d7dda2f.png";